import { Link } from "react-router-dom";
import { BACKEND, fmtDate } from "@/lib/api";

const LOOK = {
  budget: { tag: "Budget share", title: (d) => `Where income tax goes: ${d.country} ${d.word} budget ${d.fiscal_year}`, note: () => "Split in proportion to the official budget's spending by category, checked by Middle's editors.", cta: "Work out your own budget share on Middle" },
  results: { tag: "Election night", title: (d) => `${d.country} election: ${d.chamber}`, note: (d) => `Seat numbers from verified reports, as of ${d.as_of}. Middle doesn't project results.`, cta: "Follow the count live on Middle" },
  topic: { tag: "Middle's perspective", title: (d) => `${d.topic}: ${d.country}`, note: (d) => `${d.left_label} vs ${d.right_label}, and Middle's evidence-first view. AI-written from verified Facts${d.generated_at ? `, ${fmtDate(d.generated_at)}` : ""}. Middle doesn't endorse any party or position.`, cta: "See the full perspective on Middle" },
};

export const SharedCard = ({ d }) => {
  const c = d.card;
  const look = LOOK[c.kind];
  const to = c.kind === "topic" ? `/live/${d.live?.id}?tab=perspective` : `/live/${d.live?.id}`;
  return (
    <section className="space-y-4" data-testid="share-card">
      <p className="text-xs font-semibold uppercase tracking-wider text-[hsl(var(--facts))]">{look.tag}</p>
      <h1 className="text-3xl font-medium leading-tight" data-testid="share-card-title">{look.title(c.data)}</h1>
      <img src={`${BACKEND}/api/public/cards/${c.id}.png`} alt="" className="w-full rounded-2xl border border-border" data-testid="share-card-public-image" />
      {c.kind === "topic" && <p className="font-serif text-lg leading-snug" data-testid="share-card-middle-summary">{c.data.middle?.summary}</p>}
      <p className="text-xs text-slate-500">{look.note(c.data)} Shared {fmtDate(c.created_at)}.</p>
      {d.live && <Link to={to} className="inline-flex rounded-full bg-slate-900 px-5 py-2.5 text-sm font-medium text-white" data-testid="share-card-open-live">{look.cta}</Link>}
    </section>
  );
};
